import { isBefore } from "date-fns";
import {
  WINERIES,
  TANKS,
  LOTS,
  OPERATIONS,
  USERS,
  USER,
  PROTOCOLS,
  DRUGS,
  ANALYSIS,
  CLIENTS,
  TRACKING,
  UTILS,
  UNITS,
  PDF,
  RECURRENT,
  RESULTS,
  HISTORY,
  COUNT,
  UPDATE,
  ROLES,
  NEW_PASSWORD,
  SETTINGS,
  EMAIL,
  WINELABELS,
  LABELS,
  VARIETIES,
  EXPIRED,
  NOTE,
  DICTIONARY,
  WINEMAKING,
  APPLY,
  PERMISSIONS,
  EXCEL,
  QR,
  SENSORS,
  STATE,
  WORK_MODE,
  TREE,
  NOTIFICATION,
  WAREHOUSE,
  CAPS,
  STICKY_NOTE,
  SUBSTANCES,
  OIV,
  RESET,
  UPLOAD_DATASHEET,
  CLOSE,
  BUYERS,
  POMACES,
  START,
  REPORT,
  RESEND,
  VERIFY,
  AUTH,
  VERIFY_EMAIL,
  RESOURCES,
  CLIENT_NAME,
  RESET_PASSWORD,
  BARRELS,
  IMPERSONATE,
  STOP,
  ANNOUNCEMENTS,
  ADMIN_ANNOUNCEMENTS,
  DISMISS,
  DEACTIVATE,
  SUBSTATES,
  SUPPLIERS,
  VINEYARDS,
  PROTOCOL_APPLICATIONS,
  WINEMAKING_PROTOCOLS,
  ME,
  RBAC,
  ROLLBACK,
  AUDIT_LOG,
  ERROR_REPORTS,
  EXPORT_DATA,
} from "../constants/apis";

const getWineries = async (axiosInstance, jwtToken, options = {}) => {
  try {
    const response = await axiosInstance.get(WINERIES, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || [];
  } catch (e) {
    console.error(e);
    // Per default torna [] (i chiamanti delle viste lo trattano come "nessun
    // dato"). Il login passa throwOnError: così un errore reale non viene
    // scambiato per "0 cantine" → niente navigazione errata a /wineries/new.
    if (options?.throwOnError) throw e;
    return [];
  }
};

const getTanks = async (id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${TANKS}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    const filteredData = id
      ? response?.data?.filter?.((tank) => {
          return tank.winery_id === id;
        })
      : response?.data;
    return filteredData;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getSensors = async (id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${UTILS}${SENSORS}/${id}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getTankQR = async (id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${TANKS}${QR}/${id}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getTankSensorData = async (
  type,
  id,
  last_timestamp,
  axiosInstance,
  jwtToken
) => {
  try {
    const response = await axiosInstance.get(
      `${TANKS}${SENSORS}/${type}/${id}`,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
        params: {
          ...(last_timestamp && { last_timestamp: last_timestamp }),
        },
      }
    );
    return response?.data || {};
  } catch (e) {
    console.error(e);
    return {};
  }
};

const setTankSensorData = async (
  type,
  id,
  new_set_point,
  auth,
  axiosInstance,
  jwtToken
) => {
  try {
    const response = await axiosInstance.put(
      `${TANKS}${SENSORS}/${type}/${id}`,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
        params: {
          new_set_point: new_set_point,
          ...(auth && { auth: auth }),
        },
      }
    );
    return response?.data || [];
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const setTankSensorEnable = async (
  type,
  id,
  enable,
  auth,
  axiosInstance,
  jwtToken
) => {
  try {
    const enableString = enable ? "on" : "off";
    const response = await axiosInstance.put(
      `${TANKS}${SENSORS}/${type}/${id}${STATE}/${enableString}`,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
        params: {
          ...(auth && { auth: auth }),
        },
      }
    );
    return response?.data || [];
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const setTankSensorWorkMode = async (
  type,
  id,
  work_mode,
  auth,
  axiosInstance,
  jwtToken
) => {
  try {
    const response = await axiosInstance.put(
      `${TANKS}${SENSORS}/${type}/${id}${WORK_MODE}/`,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
        params: {
          work_mode: work_mode,
          ...(auth && { auth: auth }),
        },
      }
    );
    return response?.data || [];
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const getWineLabels = async (axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${WINELABELS}${LABELS}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getWineVarieties = async (axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${WINELABELS}${VARIETIES}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getOIVSubstances = async (axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(
      `${PROTOCOLS}${WINEMAKING}${OIV}${SUBSTANCES}`,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getBuyersList = async (axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${WINERIES}${BUYERS}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getPomacesList = async (axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${WINERIES}${POMACES}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getOperations = async (
  axiosInstance,
  isCompleted = false,
  user_id = null,
  completion_date = new Date(),
  jwtToken
) => {
  try {
    const response = await axiosInstance.get(`${OPERATIONS}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
      params: {
        ...(isCompleted === false
          ? { completion_date: "" }
          : { completion_date }),
      },
    });
    return user_id === null
      ? response?.data
      : response?.data.filter((op) => op.cellarman_ids.includes(user_id)) || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getExpiredOperations = async (id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${OPERATIONS}${EXPIRED}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    const filteredData = id
      ? response?.data?.filter?.((op) => {
          return op.winery_id === id;
        })
      : response?.data;
    return filteredData || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getCompletedOperationsWithPaging = async (
  axiosInstance,
  start_completion_date = new Date(),
  end_completion_date = new Date(),
  limit = 50,
  offset = 0,
  jwtToken
) => {
  try {
    const response = await axiosInstance.get(`${OPERATIONS}${HISTORY}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
      params: {
        start_completion_date,
        end_completion_date,
        limit,
        offset,
      },
    });
    return response?.data;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getCompletedOperationsCount = async (
  axiosInstance,
  start_completion_date = new Date(),
  end_completion_date = new Date(),
  jwtToken
) => {
  try {
    const response = await axiosInstance.get(
      `${OPERATIONS}${HISTORY}${COUNT}`,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
        params: {
          start_completion_date,
          end_completion_date,
        },
      }
    );
    return response?.data;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getOperationById = async (axiosInstance, id, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${OPERATIONS}/${id}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getOperationsByMainId = async (axiosInstance, main_id, jwtToken) => {
  try {
    const response = await axiosInstance.get(
      `${OPERATIONS}${RECURRENT}/${main_id}`,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getRepetitiveOperationsById = async (
  main_ids = [],
  axiosInstance,
  jwtToken
) => {
  try {
    const response = await axiosInstance.get(`${OPERATIONS}${RECURRENT}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
      params: {
        main_ids: main_ids,
      },
    });
    return response?.data || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getLotTracking = async (axiosInstance, id, dates, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${LOTS}${TRACKING}/${id}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
      params: {
        startDate: dates?.startDate,
        endDate: dates?.endDate,
      },
    });
    return response?.data || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getLotSubstates = async (axiosInstance, id, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${LOTS}${SUBSTATES}/${id}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getLotTrackingTree = async (axiosInstance, id, dates, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${LOTS}${TREE}/${id}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
      params: {
        startDate: dates?.startDate,
        endDate: dates?.endDate,
      },
    });
    return response?.data || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getTankTracking = async (axiosInstance, id, dates, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${TANKS}${TRACKING}/${id}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
      params: {
        startDate: dates?.startDate,
        endDate: dates?.endDate,
      },
    });
    return response?.data || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getTankTrackingTree = async (axiosInstance, id, dates, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${TANKS}${TREE}/${id}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
      params: {
        startDate: dates?.startDate,
        endDate: dates?.endDate,
      },
    });
    return response?.data || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getLots = async (id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${LOTS}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    const filteredData = id
      ? response?.data?.filter?.((tank) => {
          return tank.winery_id === id;
        })
      : response?.data;
    return filteredData;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getClosedBatches = async (axiosInstance, limit = 50, offset = 0, startDate = null, endDate = null) => {
  try {
    const response = await axiosInstance.get(`${LOTS}/closed`, {
      withCredentials: true,
      params: {
        limit,
        offset,
        ...(startDate && { start_date: startDate }),
        ...(endDate && { end_date: endDate }),
      },
    });
    return response?.data || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getClosedBatchesCount = async (axiosInstance, startDate = null, endDate = null) => {
  try {
    const response = await axiosInstance.get(`${LOTS}/closed/count`, {
      withCredentials: true,
      params: {
        ...(startDate && { start_date: startDate }),
        ...(endDate && { end_date: endDate }),
      },
    });
    return response?.data?.count || 0;
  } catch (e) {
    console.error(e);
    return 0;
  }
};

const getLotHistory = async (id, lotId, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${LOTS}${HISTORY}/${lotId}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const getBatchArrival = async (id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${LOTS}/${id}/arrival`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data;
  } catch (e) {
    console.error("Error fetching batch arrival data:", e);
    return null;
  }
};

const getOperationByWineryId = async (id, axiosInstance, jwtToken) => {
  try {
    const response = await getOperations(axiosInstance, jwtToken);
    const filteredByWineryData = id
      ? response?.filter?.((operation) => {
          return operation?.winery_id === id;
        })
      : response?.data;
    return filteredByWineryData;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getNextOperations = async (id, axiosInstance, jwtToken) => {
  try {
    const filteredByWineryData = await getOperationByWineryId(
      id,
      axiosInstance,
      jwtToken
    );
    const filteredByExpireDates = filteredByWineryData?.filter((operation) => {
      return (
        isBefore(new Date(), new Date(operation?.expire_date)) &&
        !operation.completaion_date
      );
    });
    return filteredByExpireDates;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getNextOperationsByTankId = async (
  wineryId,
  tankId,
  axiosInstance,
  jwtToken
) => {
  try {
    const filteredByWineryData = await getOperationByWineryId(
      wineryId,
      axiosInstance,
      jwtToken
    );
    const filteredByTankId = filteredByWineryData?.filter((operation) => {
      return (
        operation?.src_tanks?.some?.((tank) => tank?.tank_id === tankId) ||
        operation?.dest_tanks?.some?.((tank) => tank?.tank_id === tankId)
      );
    });
    return filteredByTankId;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const newUser = async (username, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.post(
      `${USERS}${USER}/${username}`,
      data,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const newTank = async (data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.post(`${TANKS}`, data, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const updateTank = async (id, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.put(`${TANKS}/${id}`, data, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const newOperation = async (data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.post(`${OPERATIONS}`, data, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const updateOperation = async (id, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.put(`${OPERATIONS}/${id}`, data, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const newWinery = async (data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.post(`${WINERIES}`, data, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const updateWinery = async (id, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.put(`${WINERIES}/${id}`, data, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const deleteWinery = async (id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.delete(`${WINERIES}/${id}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const resetWinery = async (id, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.post(
      `${WINERIES}${RESET}/${id}`,
      data,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const getProtocols = async (type, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${PROTOCOLS}/${type}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const deleteProtocol = async (id, type, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.delete(
      `${PROTOCOLS}/${type}/${id}`,
      {
        id: id,
        type: type,
      },
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const getUsers = async (axiosInstance, id, userName, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${USERS}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });

    const filteredData =
      userName !== null
        ? response?.data?.filter?.((user) => {
            return user.username !== userName;
          })
        : id
        ? response?.data?.filter?.((user) => {
            return user.id === Number(id);
          })
        : response?.data;

    return filteredData;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const deleteUser = async (username, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.delete(`${USERS}${USER}/${username}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const getDrugs = async (axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${DRUGS}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    const filteredData = response?.data
      ? response?.data?.map?.((substance) => {
          return { value: substance.id, label: substance?.name, ...substance };
        })
      : [];
    return filteredData;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const deleteDrug = async (id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.delete(`${DRUGS}/${id}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const deleteTank = async (id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.delete(`${TANKS}/${id}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const closeTank = async (id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.delete(`${TANKS}${CLOSE}/${id}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const deleteLot = async (id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.delete(`${LOTS}/${id}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const closeLot = async (id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.delete(`${LOTS}${CLOSE}/${id}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const deleteOperation = async (id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.delete(`${OPERATIONS}/${id}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const completeOperation = async (id, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.post(`${OPERATIONS}/${id}`, data, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const startOperation = async (id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.post(`${OPERATIONS}${START}/${id}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const getRollbackImpact = async (id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(
      `${OPERATIONS}${ROLLBACK}/${id}/impact`,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const rollbackOperation = async (id, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.post(
      `${OPERATIONS}${ROLLBACK}/${id}`,
      data,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const addOperationNote = async (id, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.post(
      `${OPERATIONS}${NOTE}/${id}`,
      data,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const addAnalysisSample = async (id, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.post(
      `${PROTOCOLS}${ANALYSIS}${RESULTS}/${id}`,
      data,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const getExams = async (axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${ANALYSIS}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    const filteredData = response?.data
      ? response?.data?.map?.((substance) => {
          return { value: substance.id, label: substance.name, ...substance };
        })
      : [];
    return filteredData;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getUnits = async (axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${UTILS}${UNITS}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    const filteredData = response?.data
      ? response?.data?.map?.((unit) => {
          return { value: unit.id, label: unit?.unit, ...unit };
        })
      : [];
    return filteredData;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getPermissions = async (axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${UTILS}${PERMISSIONS}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getRoles = async (axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${UTILS}${ROLES}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getResources = async (axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${UTILS}${RESOURCES}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getUserRbac = async (axiosInstance) => {
  try {
    const response = await axiosInstance.get(`${USERS}${ME}${RBAC}`, {
      withCredentials: true,
    });

    // Try different response formats - backend might return { permissions: {...} } or just {...}
    let permissions = response?.data?.permissions || response?.data || {};

    return permissions;
  } catch (e) {
    console.error(e);
    return {};
  }
};

const getClients = async (id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${CLIENTS}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    const filteredData = id
      ? response?.data?.filter?.((client) => {
          return client.id === id;
        })
      : response?.data;

    return filteredData;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const updateClient = async (username, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.put(
      `${CLIENTS}${CLIENTS}/${username}`,
      data,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const deleteClient = async (username, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.delete(
      `${CLIENTS}${CLIENTS}/${username}`,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const deleteLicense = async (client_name, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.delete(
      `${CLIENTS}${CLIENT_NAME}/${client_name}`,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const extendClientLicense = async (client_name, years, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.put(
      `${CLIENTS}${CLIENT_NAME}/${client_name}`,
      { years },
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const resetClientPassword = async (email, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.put(
      `${CLIENTS}${RESET_PASSWORD}`,
      { email },
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const updateClientRoles = async (user_id, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.put(
      `${USERS}${UPDATE}${ROLES}/${user_id}`,
      data,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const updateClientWineries = async (user_id, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.put(
      `${USERS}${UPDATE}${WINERIES}/${user_id}`,
      data,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const newClient = async (username, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.post(
      `${CLIENTS}${CLIENTS}/${username}`,
      data,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const uploadDrugTechnicalDatasheet = async (
  id,
  data,
  axiosInstance,
  jwtToken
) => {
  try {
    const response = await axiosInstance.post(
      `${PROTOCOLS}${DRUGS}/${id}${UPLOAD_DATASHEET}`,
      data,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response?.data || null;
  } catch (e) {
    console.error(e);
    return e?.response?.data || null;
  }
};

const getAnalysisResults = async (
  operation_ids = [],
  axiosInstance,
  jwtToken
) => {
  try {
    const response = await axiosInstance.get(
      `${PROTOCOLS}${ANALYSIS}${RESULTS}`,

      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
        params: {
          operation_ids,
        },
      }
    );

    return response?.data || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const newLot = async (data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.post(`${LOTS}`, data, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const updateLot = async (id, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.put(`${LOTS}/${id}`, data, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const getPDF = async (data, axiosInstance, type, file_type, jwtToken) => {
  try {
    const response = await axiosInstance.post(
      `${UTILS}${file_type === "EXCEL" ? EXCEL : PDF}`,
      data,
      {
        responseType: "blob",
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );

    // check the response status
    if (response.status === 200) {
      // create file link in browser's memory
      const href = URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute(
        "download",
        `${
          data?.additionalData?.fileName || type || "programming"
        }_${new Date().toLocaleDateString("it-IT")}.${
          file_type === "EXCEL" ? "xlsx" : "pdf"
        }`
      );
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(href);

      return true; // Indicate success
    } else {
      console.error("Unexpected response status:", response.status);
      return null; // Handle unexpected status
    }
  } catch (e) {
    console.error("Error while fetching PDF:", e);
    return null; // Handle error
  }
};

const getWineryDataExport = async (wineryId, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${EXPORT_DATA}/${wineryId}`, {
      responseType: "blob",
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });

    if (response.status === 200) {
      const href = URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute(
        "download",
        `export_${new Date().toLocaleDateString("it-IT")}.xlsx`
      );
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(href);

      return true;
    } else {
      console.error("Unexpected response status:", response.status);
      return null;
    }
  } catch (e) {
    console.error("Error while fetching data export:", e);
    return null;
  }
};

const newProtocol = async (type, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.post(`${PROTOCOLS}/${type}`, data, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const updateProtocol = async (id, type, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.put(
      `${PROTOCOLS}/${type}/${id}`,
      data,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const newDrug = async (data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.post(`${DRUGS}`, data, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const updateDrug = async (id, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.put(`${DRUGS}/${id}`, data, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const updateDrugWarehouse = async (id, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.put(
      `${DRUGS}${WAREHOUSE}/${id}`,
      data,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const updateUserPassword = async (
  oldPassword,
  password,
  axiosInstance,
  jwtToken
) => {
  try {
    const response = await axiosInstance.put(
      `${USERS}${UPDATE}${NEW_PASSWORD}`,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
        params: {
          ...(oldPassword ? { oldPassword } : { oldPassword: "" }),
          ...(password ? { password } : { password: "" }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const resendNewClientEmail = async (email, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.put(`${USERS}${RESEND}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
      params: {
        email,
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const verifyClientEmailByToken = async (token, axiosInstance) => {
  try {
    const res = await axiosInstance.post(`${AUTH}${VERIFY}${EMAIL}`, { token });
    return res?.status === 200;
  } catch (err) {
    console.error(err);
    return false;
  }
};

const updateUserEmail = async (email, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.put(`${USERS}${UPDATE}${EMAIL}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
      params: {
        ...(email ? { email } : { email: "" }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const updateUserSetting = async (key, value, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.put(`${USERS}${UPDATE}${SETTINGS}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
      params: {
        ...(key && value ? { key: key, value: value } : { key: "", value: "" }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const impersonateUser = async (targetUserId, axiosInstance) => {
  try {
    const response = await axiosInstance.post(`${IMPERSONATE}${START}`, {
      targetUserId,
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const stopImpersonation = async (axiosInstance) => {
  try {
    const response = await axiosInstance.post(`${IMPERSONATE}${STOP}`);
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const updateSubtypePermissions = async (
  data,
  axiosInstance,
  jwtToken
) => {
  try {
    const response = await axiosInstance.put(
      `${USERS}${UPDATE}${PERMISSIONS}`,
      data,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const updateUser = async (id, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.put(`${USERS}${USER}/${id}`, data, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const getLabelByArea = async (area, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${DICTIONARY}/${area}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        "Accept-Language": "it", //userLang
      },
    });
    return response || [];
  } catch (e) {
    console.error(e);
    return [{ data: [] }];
  }
};

const applyWorkingProtocolOperation = async (data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.post(
      `${PROTOCOLS}${WINEMAKING}${APPLY}`,
      data,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const updateWorkingProtocol = async (id, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.put(
      `${PROTOCOLS}${WINEMAKING}/${id}`,
      data,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const markNotificationAsRead = async (id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.put(`${OPERATIONS}${NOTE}/${id}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const getWarehouseByType = async (axiosInstance, type, jwtToken, options = {}) => {
  const { includeDeactivated = false } = options;
  const params = includeDeactivated ? "?include_deactivated=true" : "";
  try {
    const response = await axiosInstance.get(`${WAREHOUSE}/${type}${params}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const newWarehouseByType = async (type, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.post(`${WAREHOUSE}/${type}`, data, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const updateWarehouseByType = async (
  type,
  id,
  data,
  axiosInstance,
  jwtToken
) => {
  try {
    const response = await axiosInstance.put(
      `${WAREHOUSE}/${type}/${id}`,
      data,
      {
        withCredentials: true,
        headers: {
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const deleteWarehouseByType = async (type, id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.delete(`${WAREHOUSE}/${type}/${id}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const rectifyWarehouseByType = async (type, id, data, axiosInstance) => {
  try {
    const response = await axiosInstance.post(
      `${WAREHOUSE}/${type}/${id}/rectify`,
      data,
      { withCredentials: true }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const getStickyNote = async (axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${UTILS}${STICKY_NOTE}`, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const updateStickyNote = async (data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.put(`${UTILS}${STICKY_NOTE}`, data, {
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

const getReportByType = async (type, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${REPORT}/${type}`, {
      params: data,
      withCredentials: true,
      headers: {
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    // return { data: e.response?.data || null, status: e.response?.status || 500 };
    throw e;
  }
};

// SUPPLIERS
const getSuppliers = async (winery_id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${SUPPLIERS}`, {
      withCredentials: true,
      headers: {
        wineryid: winery_id,
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getSupplier = async (winery_id, id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(
      `${SUPPLIERS}/${id}`,
      {
        withCredentials: true,
        headers: {
          wineryid: winery_id,
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    return null;
  }
};

const newSupplier = async (winery_id, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.post(
      `${SUPPLIERS}`,
      data,
      {
        withCredentials: true,
        headers: {
          wineryid: winery_id,
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const updateSupplier = async (winery_id, id, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.put(
      `${SUPPLIERS}/${id}`,
      data,
      {
        withCredentials: true,
        headers: {
          wineryid: winery_id,
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const deleteSupplier = async (winery_id, id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.delete(
      `${SUPPLIERS}/${id}`,
      {
        withCredentials: true,
        headers: {
          wineryid: winery_id,
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

// VINEYARDS
const getVineyards = async (winery_id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(`${VINEYARDS}`, {
      withCredentials: true,
      headers: {
        wineryid: winery_id,
        ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
      },
    });
    return response?.data || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getVineyard = async (winery_id, id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.get(
      `${VINEYARDS}/${id}`,
      {
        withCredentials: true,
        headers: {
          wineryid: winery_id,
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    return null;
  }
};

const newVineyard = async (winery_id, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.post(
      `${VINEYARDS}`,
      data,
      {
        withCredentials: true,
        headers: {
          wineryid: winery_id,
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const updateVineyard = async (winery_id, id, data, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.put(
      `${VINEYARDS}/${id}`,
      data,
      {
        withCredentials: true,
        headers: {
          wineryid: winery_id,
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const deleteVineyard = async (winery_id, id, axiosInstance, jwtToken) => {
  try {
    const response = await axiosInstance.delete(
      `${VINEYARDS}/${id}`,
      {
        withCredentials: true,
        headers: {
          wineryid: winery_id,
          ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
        },
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

// ---- Protocol Applications ----

const getProtocolApplications = async (axiosInstance) => {
  try {
    const response = await axiosInstance.get(PROTOCOL_APPLICATIONS, {
      withCredentials: true,
    });
    return response?.data?.applications || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const createProtocolApplication = async (data, axiosInstance) => {
  try {
    const response = await axiosInstance.post(PROTOCOL_APPLICATIONS, data, {
      withCredentials: true,
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const deleteProtocolApplication = async (id, reason, axiosInstance) => {
  try {
    const response = await axiosInstance.delete(
      `${PROTOCOL_APPLICATIONS}/${id}`,
      {
        data: { reason },
        withCredentials: true,
      }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const getProtocolApplicationStatus = async (id, axiosInstance) => {
  try {
    const response = await axiosInstance.get(
      `${PROTOCOL_APPLICATIONS}/${id}/status`,
      { withCredentials: true }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    return null;
  }
};

const validateAllSteps = async (id, axiosInstance) => {
  try {
    const response = await axiosInstance.post(
      `${PROTOCOL_APPLICATIONS}/${id}/validate-all`,
      {},
      { withCredentials: true }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const configureStep = async (stepId, data, axiosInstance) => {
  try {
    const response = await axiosInstance.put(
      `${PROTOCOL_APPLICATIONS}/steps/${stepId}/configure`,
      data,
      { withCredentials: true }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const executeStep = async (stepId, data, axiosInstance) => {
  try {
    const response = await axiosInstance.post(
      `${PROTOCOL_APPLICATIONS}/steps/${stepId}/execute`,
      data,
      { withCredentials: true }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const autoAdaptStep = async (stepId, axiosInstance) => {
  try {
    const response = await axiosInstance.post(
      `${PROTOCOL_APPLICATIONS}/steps/${stepId}/auto-adapt`,
      {},
      { withCredentials: true }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const getStepValidationHistory = async (stepId, axiosInstance) => {
  try {
    const response = await axiosInstance.get(
      `${PROTOCOL_APPLICATIONS}/steps/${stepId}/validation-history`,
      { withCredentials: true }
    );
    return response?.data || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getStepVirtualState = async (stepId, axiosInstance) => {
  try {
    const response = await axiosInstance.get(
      `${PROTOCOL_APPLICATIONS}/steps/${stepId}/virtual-state`,
      { withCredentials: true }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    return null;
  }
};

const getWineMakingProtocols = async (axiosInstance) => {
  try {
    const response = await axiosInstance.get(WINEMAKING_PROTOCOLS, {
      withCredentials: true,
    });
    return response?.data || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getSingleWineMakingProtocol = async (id, axiosInstance) => {
  try {
    const response = await axiosInstance.get(`${WINEMAKING_PROTOCOLS}/${id}`, {
      withCredentials: true,
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    return null;
  }
};

const createWineMakingProtocol = async (data, axiosInstance) => {
  try {
    const response = await axiosInstance.post(WINEMAKING_PROTOCOLS, data, {
      withCredentials: true,
    });
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const updateWineMakingProtocol = async (id, data, axiosInstance) => {
  try {
    const response = await axiosInstance.put(
      `${WINEMAKING_PROTOCOLS}/${id}`,
      data,
      { withCredentials: true }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const deleteWineMakingProtocol = async (id, axiosInstance) => {
  try {
    const response = await axiosInstance.delete(
      `${WINEMAKING_PROTOCOLS}/${id}`,
      { withCredentials: true }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const getAuditLog = async (axiosInstance, params = {}) => {
  try {
    const response = await axiosInstance.get(AUDIT_LOG, {
      withCredentials: true,
      params,
    });
    return response?.data || { data: [], total: 0, page: 0, limit: 20 };
  } catch (e) {
    console.error(e);
    return { data: [], total: 0, page: 0, limit: 20 };
  }
};

const getBarrelsByTank = async (axiosInstance, tankId) => {
  try {
    const response = await axiosInstance.get(BARRELS, {
      withCredentials: true,
      params: { tank_id: tankId },
    });
    return response?.data || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getBarrelHistory = async (axiosInstance, barrelId) => {
  try {
    const response = await axiosInstance.get(`${BARRELS}/${barrelId}/history`, {
      withCredentials: true,
    });
    return response?.data || { barrel: null, assignments: [] };
  } catch (e) {
    console.error(e);
    return { barrel: null, assignments: [] };
  }
};

const createBarrelsBatch = async (tankId, groups, axiosInstance) => {
  try {
    const response = await axiosInstance.post(
      BARRELS,
      { tank_id: tankId, groups },
      { withCredentials: true }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const retireBarrel = async (barrelId, retiredReason, axiosInstance) => {
  try {
    const response = await axiosInstance.post(
      `${BARRELS}/${barrelId}/retire`,
      { retired_reason: retiredReason },
      { withCredentials: true }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const moveBarrel = async (barrelId, newTankId, axiosInstance) => {
  try {
    const response = await axiosInstance.post(
      `${BARRELS}/${barrelId}/move`,
      { new_tank_id: newTankId },
      { withCredentials: true }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const updateBarrelSerial = async (barrelId, serialNumber, axiosInstance) => {
  try {
    const response = await axiosInstance.patch(
      `${BARRELS}/${barrelId}`,
      { serial_number: serialNumber },
      { withCredentials: true }
    );
    return response?.data || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const getErrorReports = async (axiosInstance, params = {}) => {
  try {
    const response = await axiosInstance.get(ERROR_REPORTS, {
      withCredentials: true,
      params,
    });
    return response?.data || { data: [], total: 0, page: 0, limit: 20 };
  } catch (e) {
    console.error(e);
    return { data: [], total: 0, page: 0, limit: 20 };
  }
};

const getActiveAnnouncements = async (axiosInstance) => {
  try {
    const response = await axiosInstance.get(ANNOUNCEMENTS);
    return response?.data || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const dismissAnnouncement = async (id, axiosInstance) => {
  try {
    await axiosInstance.post(`${ANNOUNCEMENTS}/${id}${DISMISS}`);
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const getAllAnnouncements = async (axiosInstance) => {
  try {
    const response = await axiosInstance.get(ADMIN_ANNOUNCEMENTS);
    return response?.data || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const createAnnouncement = async (data, axiosInstance) => {
  const response = await axiosInstance.post(ADMIN_ANNOUNCEMENTS, data);
  return response?.data || null;
};

const deactivateAnnouncement = async (id, axiosInstance) => {
  const response = await axiosInstance.patch(`${ADMIN_ANNOUNCEMENTS}/${id}${DEACTIVATE}`);
  return response?.data || null;
};

export {
  getWineries,
  newWinery,
  updateWinery,
  deleteWinery,
  resetWinery,
  getTanks,
  getSensors,
  getTankQR,
  getTankSensorData,
  setTankSensorData,
  setTankSensorEnable,
  setTankSensorWorkMode,
  getWineLabels,
  getWineVarieties,
  newTank,
  updateTank,
  deleteTank,
  closeTank,
  getBarrelsByTank,
  getBarrelHistory,
  createBarrelsBatch,
  retireBarrel,
  moveBarrel,
  updateBarrelSerial,
  getOIVSubstances,
  getBuyersList,
  getPomacesList,
  getOperations,
  getExpiredOperations,
  getOperationByWineryId,
  getNextOperationsByTankId,
  getNextOperations,
  addOperationNote,
  getUsers,
  newUser,
  deleteUser,
  getLots,
  getClosedBatches,
  getClosedBatchesCount,
  getLotHistory,
  newLot,
  updateLot,
  deleteLot,
  closeLot,
  getProtocols,
  getDrugs,
  getExams,
  getClients,
  updateClient,
  deleteClient,
  deleteLicense,
  extendClientLicense,
  resetClientPassword,
  updateClientRoles,
  updateClientWineries,
  newClient,
  newProtocol,
  updateProtocol,
  deleteProtocol,
  newDrug,
  deleteDrug,
  updateDrug,
  updateDrugWarehouse,
  newOperation,
  updateOperation,
  deleteOperation,
  completeOperation,
  startOperation,
  rollbackOperation,
  getRollbackImpact,
  addAnalysisSample,
  getPDF,
  getWineryDataExport,
  getUnits,
  getPermissions,
  getRoles,
  getResources,
  getUserRbac,
  getLotSubstates,
  getLotTracking,
  getLotTrackingTree,
  getBatchArrival,
  uploadDrugTechnicalDatasheet,
  getAnalysisResults,
  getRepetitiveOperationsById,
  getOperationById,
  getOperationsByMainId,
  getTankTracking,
  getTankTrackingTree,
  getCompletedOperationsWithPaging,
  getCompletedOperationsCount,
  updateUserPassword,
  resendNewClientEmail,
  verifyClientEmailByToken,
  updateUserEmail,
  updateUser,
  updateSubtypePermissions,
  updateUserSetting,
  impersonateUser,
  stopImpersonation,
  applyWorkingProtocolOperation,
  updateWorkingProtocol,
  getLabelByArea,
  markNotificationAsRead,
  getWarehouseByType,
  newWarehouseByType,
  updateWarehouseByType,
  deleteWarehouseByType,
  rectifyWarehouseByType,
  getStickyNote,
  updateStickyNote,
  getReportByType,
  getSuppliers,
  getSupplier,
  newSupplier,
  updateSupplier,
  deleteSupplier,
  getVineyards,
  getVineyard,
  newVineyard,
  updateVineyard,
  deleteVineyard,
  getProtocolApplications,
  createProtocolApplication,
  deleteProtocolApplication,
  getProtocolApplicationStatus,
  validateAllSteps,
  configureStep,
  executeStep,
  autoAdaptStep,
  getStepValidationHistory,
  getStepVirtualState,
  getWineMakingProtocols,
  getSingleWineMakingProtocol,
  createWineMakingProtocol,
  updateWineMakingProtocol,
  deleteWineMakingProtocol,
  getAuditLog,
  getErrorReports,
  getActiveAnnouncements,
  dismissAnnouncement,
  getAllAnnouncements,
  createAnnouncement,
  deactivateAnnouncement,
};
